@if (visible$ | async) {
<div class="product-variation-container">
  @if ('preferences.ChannelPreferences.EnableAdvancedVariationHandling' | ishServerSetting) {
  <ish-product-variation-display />
  <ish-product-master-link />
  } @else {
  <ish-product-variation-select />
  }
</div>
}
